// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"b87333af","352":"ec056473","869":"421f3711"}[chunkId] + ".css";
};